<template>

    <Head title="Habilitese - Forum"></Head>
    <div class="card shadow-sm">
        <div class="card-header">
            <div class="col-5 card-toolbar">
                <h3 class="card-title col-10">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#494b74">
                        <path d="M20 19.725V18.725C20 18.125 19.6 17.725 19 17.725H5C4.4 17.725 4 18.125 4 18.725V19.725H3C2.4 19.725 2 20.125 2 20.725V21.725H22V20.725C22 20.125 21.6 19.725 21 19.725H20Z" fill="#494b74"></path>
                        <path opacity="0.3" d="M22 6.725V7.725C22 8.325 21.6 8.725 21 8.725H18C18.6 8.725 19 9.125 19 9.725C19 10.325 18.6 10.725 18 10.725V15.725C18.6 15.725 19 16.125 19 16.725V17.725H15V16.725C15 16.125 15.4 15.725 16 15.725V10.725C15.4 10.725 15 10.325 15 9.725C15 9.125 15.4 8.725 16 8.725H13C13.6 8.725 14 9.125 14 9.725C14 10.325 13.6 10.725 13 10.725V15.725C13.6 15.725 14 16.125 14 16.725V17.725H10V16.725C10 16.125 10.4 15.725 11 15.725V10.725C10.4 10.725 10 10.325 10 9.725C10 9.125 10.4 8.725 11 8.725H8C8.6 8.725 9 9.125 9 9.725C9 10.325 8.6 10.725 8 10.725V15.725C8.6 15.725 9 16.125 9 16.725V17.725H5V16.725C5 16.125 5.4 15.725 6 15.725V10.725C5.4 10.725 5 10.325 5 9.725C5 9.125 5.4 8.725 6 8.725H3C2.4 8.725 2 8.325 2 7.725V6.725L11 2.225C11.6 1.925 12.4 1.925 13.1 2.225L22 6.725ZM12 3.725C11.2 3.725 10.5 4.425 10.5 5.225C10.5 6.025 11.2 6.725 12 6.725C12.8 6.725 13.5 6.025 13.5 5.225C13.5 4.425 12.8 3.725 12 3.725Z" fill="#494b74"></path>
                    </svg>
                    &nbsp;&nbsp; Moderação forum
                </h3>
            </div>
            <div class="card-toolbar">
                <a href="/dashboard/admin" class="btn btn-secondary">
                    <i class="fa fa-reply"></i>
                    Voltar
                </a>
            </div>
        </div>
    </div>
    <div class="my-3" v-for="course in props.list_all_courses_with_modules" :key="course.id" :id="course.id.toString()">
        <div class="card card-flush">
            <div class="card-header pt-7">
                <div class="col-11 row align-items-left">
                    <h4 class="col-9">
                        {{ course.description }}
                    </h4>
                    <div class="col">
                        <p v-if="course.have_item_to_moderation" class="badge badge-danger">POSTS PENDENTE</p>
                    </div>
                </div>
                <div>
                    <button :id="'btn-' + course.id" class="btn btn-sm btn-icon btn-bg-light rotate-icon" @click="toggleHidden(course.id)">
                        <i class="fas fa-angle-double-down"></i>
                    </button>
                </div>
            </div>
            <div class="card-body py-1" v-if="course.opened">
                <div class="separator separator-solid"></div>
                <div class="separator separator-solid mb-1"></div>
                <div class="table-responsive">
                    <table class="table table-row-dashed align-middle gs-0 gy-4 my-0">
                        <thead>
                            <tr class="border-bottom-0">
                                <th class="p-0 min-w-100px"></th>
                                <th class="p-0 min-w-5px"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="ps-0">
                                    <div class="text-gray-900 fw-bold text-hover-primary mb-1 fs-6"></div>
                                    <div v-for="module in course.modules" :key="module.id" class="row align-items-center">
                                        <div class="col-9">
                                            <div>
                                                {{ module.name }}
                                                <div v-if="!module.count_news" class="my-1 badge badge-success p-1" style="min-width: 130px">POSTS APROVADOS</div>
                                                <div v-if="module.count_news" class="my-1 badge badge-danger p-1" style="min-width: 130px">POSTS PENDENTE</div>
                                            </div>
                                        </div>
                                        <div class="col-3 d-flex justify-content-end">
                                            <a :href="module.url_forum" class="btn btn-sm btn-primary btn-block my-2" style="min-width: 130px">Abrir tópicos</a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>


<script setup lang="ts">
export type ModuleWithRoute = {
    id: number,
    sequence: string,
    enabled: string,
    name: string,
    url_forum: string,
    count_news: number,
}

export type CourseModule = {
    id: number,
    description: string,
    opened: boolean,
    modules: Array<ModuleWithRoute>,
    have_item_to_moderation: boolean
}

var showInfo: Array<boolean> = [];
var count: number = 1;
const props = defineProps({
    list_all_courses_with_modules: { type: Array<CourseModule>, required: true }
})

function toggleHidden(id) {
    console.log(id);
    const icon = document.getElementById(`btn-${id}`);
    icon?.classList.toggle('active');
    const div = document.getElementById(id); // Alterna o estado
    props.list_all_courses_with_modules.filter((data) => {
        if (data.id === id) {
            data.opened = !data.opened;
        };
    });
}

</script>

<style>
.div-clicavel {
    cursor: pointer;
    border: 1px solid black;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.7s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.rotate-icon {
    transition: transform 0.3s ease-in-out;
}

.rotate-icon.active {
    transform: rotate(180deg);
}
</style>
